import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SearchHeadComponent } from './search-head.component'
import { SharedModule } from '../shared/shared.module'

@NgModule({
  declarations: [SearchHeadComponent],
  imports: [CommonModule, SharedModule],
  exports: [SearchHeadComponent],
})
export class SearchHeadModule {}
